export function matchCategoryByName<T extends { name?: string | null }>(
  categories: T[] | null | undefined,
  rawName: string | null | undefined
): T | null {
  const needle = rawName?.trim().toLowerCase();
  if (!needle || !categories?.length) {
    return null;
  }

  return categories.find((category) => category.name?.trim().toLowerCase() === needle) ?? null;
}
